import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(function Input({ className, type, ...props }, ref) {
  const isColorInput = type === "color";

  return (
    <input
      ref={ref}
      className={cn(
        "h-10 w-full rounded-xl border border-border bg-white/[0.035] px-3 py-2 text-sm text-foreground shadow-sm outline-none transition-colors placeholder:text-muted-foreground/60 focus-visible:border-ring focus-visible:bg-white/[0.08] focus-visible:ring-2 focus-visible:ring-ring/35 disabled:cursor-not-allowed disabled:opacity-50",
        isColorInput &&
          "cursor-pointer overflow-hidden [&::-webkit-color-swatch-wrapper]:rounded-[inherit] [&::-webkit-color-swatch-wrapper]:px-2 [&::-webkit-color-swatch-wrapper]:py-[6px] [&::-webkit-color-swatch]:rounded-[inherit] [&::-webkit-color-swatch]:border-0 [&::-moz-color-swatch]:rounded-[inherit] [&::-moz-color-swatch]:border-0",
        className,
      )}
      data-slot="input"
      type={type}
      {...props}
    />
  );
});

export { Input };
